import { Component } from '@angular/core';

import { ApContentModule } from '@ap/content';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApIconButtonLinkComponent } from '@ap/icon-link';

@Component({
    selector: 'ap-previous-button',
    templateUrl: './previous-button.component.html',
    standalone: true,
    imports: [ApContentModule, ApAnalyticsModule, ApIconButtonLinkComponent]
})
export class PreviousButtonComponent {}
